import { render, staticRenderFns } from "./PendingItemsPage.vue?vue&type=template&id=ba3d8560&"
import script from "./PendingItemsPage.vue?vue&type=script&lang=js&"
export * from "./PendingItemsPage.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/repdashboard.css?vue&type=style&index=0&lang=css&"
import style1 from "./PendingItemsPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports